import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import { Capacitor } from '@capacitor/core';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Amplify v6 config with dynamic redirect URIs (matches current origin on web,
// Capacitor scheme on native). Kept here because aws-exports.js is regenerated
// by `amplify push` and would lose inline edits.
const isNative = Capacitor.isNativePlatform();
const webOrigin = typeof window !== 'undefined' ? window.location.origin : '';

const redirectSignIn = isNative
  ? ['capacitor://localhost/auth/callback']
  : [`${webOrigin}/auth/callback`];

const redirectSignOut = isNative
  ? ['capacitor://localhost/login']
  : [`${webOrigin}/login`];

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-2_DM6JEp29r',
      userPoolClientId: '2rs861uvopg96fc13bkdp1usqq',
      identityPoolId: 'eu-west-2:cbf07779-5bb9-4d40-861d-d79407f83537',
      loginWith: {
        oauth: {
          domain: 'streaks-wolf.auth.eu-west-2.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register();
